import {
  GetEsignatureSignaturesDocument,
  GetEsignatureSignaturesQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type EsignatureSignature =
  GetEsignatureSignaturesQuery['esignature']['signaturesConnection']['nodes'][number]

export const useGetEsignatureSignatures = (documentId: number) => {
  const { loading, data, startPolling, stopPolling } = useQuery(GetEsignatureSignaturesDocument, {
    variables: { documentId },
  })

  return {
    loadingQL: loading,
    signatures: data?.esignature.signaturesConnection.nodes ?? [],
    startSignaturesPolling: startPolling,
    stopSignaturesPolling: stopPolling,
  }
}
